import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { videos } from 'src/constants/videos'
export default (props) => {
  return (
    <USTemplateDefault
      location={props.location}
      lang="en"
      market="us"
      video={videos.nbatv.videoUrl}
      title="Stream NBA TV with Fubo"
      subtitle="Catch live games, shows and highlights"
      networkSet="basketball"
      league="nba"
      showRSN={true}
    />
  )
}
